/* =========================================================
   Sports n deco — Moteur "COURT de tennis" (navigateur)
   Affiche épurée : le court (double, filet + toutes les lignes) en grand,
   fond pleine page selon la surface. Terre / Gazon / Dur (bleu) / Intérieur (gris).
   API : SNTennisCourt.render(data) -> string SVG
     data : { surface:'terre'|'gazon'|'dur'|'interieur', title, subtitle }
   ========================================================= */
(function () {
  const PW = 800, PH = 1066;
  const SURF = {
    terre:     { label:'Terre battue', court:'#c15b3c', run:'#a54c31', line:'#ffffff', ink:'#ffffff', sub:'rgba(255,255,255,0.82)' },
    gazon:     { label:'Gazon',        court:'#3f8047', run:'#33693a', line:'#ffffff', ink:'#ffffff', sub:'rgba(255,255,255,0.82)' },
    dur:       { label:'Dur',          court:'#2f6fa8', run:'#255a8a', line:'#ffffff', ink:'#ffffff', sub:'rgba(255,255,255,0.85)' },
    interieur: { label:'Intérieur',    court:'#5c6470', run:'#4a515b', line:'#ffffff', ink:'#ffffff', sub:'rgba(255,255,255,0.85)' },
  };
  const esc = s => String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  const T=(x,y,t,s,w,f,ls)=>`<text x="${x}" y="${y}" font-size="${s}" font-weight="${w}" fill="${f}" text-anchor="middle"${ls?` letter-spacing="${ls}"`:''}>${esc(t)}</text>`;

  function render(data){
    data = data || {};
    const s = SURF[data.surface] || SURF.terre;
    const cx = PW/2;
    const courtLen = 920, courtW = courtLen/2.0, cX = cx - courtW/2, cY = (PH - courtLen)/2;
    const nx = a => cX + a*courtW, ny = b => cY + b*courtLen;
    const L = s.line, sw = 3;
    const line=(x1,y1,x2,y2,w)=>`<line x1="${nx(x1).toFixed(1)}" y1="${ny(y1).toFixed(1)}" x2="${nx(x2).toFixed(1)}" y2="${ny(y2).toFixed(1)}" stroke="${L}" stroke-width="${w||sw}"/>`;

    let court = `<rect x="${cX.toFixed(1)}" y="${cY.toFixed(1)}" width="${courtW.toFixed(1)}" height="${courtLen.toFixed(1)}" fill="${s.court}"/>`;
    // rectangle des doubles (bord extérieur)
    court += `<rect x="${cX.toFixed(1)}" y="${cY.toFixed(1)}" width="${courtW.toFixed(1)}" height="${courtLen.toFixed(1)}" fill="none" stroke="${L}" stroke-width="${sw}"/>`;
    // lignes de simple (couloirs)
    court += line(0.125,0,0.125,1) + line(0.875,0,0.875,1);
    // lignes de service (dans le simple)
    court += line(0.125,0.231,0.875,0.231) + line(0.125,0.769,0.875,0.769);
    // ligne médiane de service
    court += line(0.5,0.231,0.5,0.769);
    // marques centrales aux fonds
    court += line(0.5,0,0.5,0.02) + line(0.5,0.98,0.5,1);
    // filet (léger débord + sangle centrale)
    court += `<line x1="${(nx(0)-16).toFixed(1)}" y1="${ny(0.5).toFixed(1)}" x2="${(nx(1)+16).toFixed(1)}" y2="${ny(0.5).toFixed(1)}" stroke="${L}" stroke-width="4.5"/>`;
    court += `<line x1="${(nx(0)-16).toFixed(1)}" y1="${(ny(0.5)-8).toFixed(1)}" x2="${(nx(0)-16).toFixed(1)}" y2="${(ny(0.5)+8).toFixed(1)}" stroke="${L}" stroke-width="3"/>`;
    court += `<line x1="${(nx(1)+16).toFixed(1)}" y1="${(ny(0.5)-8).toFixed(1)}" x2="${(nx(1)+16).toFixed(1)}" y2="${(ny(0.5)+8).toFixed(1)}" stroke="${L}" stroke-width="3"/>`;
    court += `<line x1="${nx(0.5).toFixed(1)}" y1="${(ny(0.5)-7).toFixed(1)}" x2="${nx(0.5).toFixed(1)}" y2="${(ny(0.5)+7).toFixed(1)}" stroke="${L}" stroke-width="3.5"/>`;

    const title = (data.title||'').trim();
    const subtitle = (data.subtitle!=null ? String(data.subtitle) : s.label).trim();

    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${PW} ${PH}" font-family="'Sora','Inter',sans-serif">
<rect width="${PW}" height="${PH}" fill="${s.run}"/>
${court}
${title ? T(cx, 52, title.toUpperCase(), 30, 800, s.ink, 1) : ''}
${subtitle ? T(cx, PH-36, subtitle.toUpperCase(), 15, 600, s.sub, 5) : ''}
</svg>`;
  }

  window.SNTennisCourt = { render, SURF, PW, PH };
})();
